import { createApp, Component, ComponentInternalInstance } from 'vue'

const useAppendComponent = () => {
  const renderComponent = ({
    element,
    component,
    props,
    appContext,
  }: {
    element: Element
    component: Component
    props: { [key: string]: any }
    appContext: ComponentInternalInstance
  }) => {
    const app = createApp(component, props)
    Object.assign(app._context, appContext)
    app.mount(element)
  }

  return { renderComponent }
}

export default useAppendComponent
